
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import Head from "next/head"

import SEO from "@/meta/SEO"
import { getHelpCenterArticleProps } from "@/organisms/HelpCenterArticle/functions/getHelpCenterArticleProps"
import HelpCenterArticle from "@/organisms/HelpCenterArticle/HelpCenterArticle"
import Help from "@/templates/Help/Help"

function ReturnsAndComplaints() {
  const sectionsList = [
    ["can_i_return_fansi_collection_product", "mailto:info@fansi.pl"],
    ["is_it_possible_to_return_product_for_different_size"],
    ["when_will_i_get_refund", "mailto:info@fansi.pl"],
    ["can_i_change_iban_to_refund"],
    ["can_i_make_complaint"],
  ]

  const props = getHelpCenterArticleProps(
    "helpReturnsAndComplaints",
    "returns_and_complaints",
    sectionsList
  )

  return (
    <>
      <Head>
        <title>Centrum pomocy | fansi.pl</title>
        <SEO description="W Centrum Pomocy znajdziesz odpowiedzi na najczęściej zadawane pytania dotyczące platformy fansi, logowania oraz zakupu produktów od influencerów." />
        {/* <meta name="robots" content="noindex,nofollow" /> */}
      </Head>
      <HelpCenterArticle {...props} />
    </>
  )
}
ReturnsAndComplaints.Layout = Help
export default ReturnsAndComplaints


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        
// @ts-ignore
        
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          props: {
// @ts-ignore
            
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/help/returns-and-complaints',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  